module.exports = __webpack_public_path__ + "static/media/banner-reclame-aqui.5886bd6f.jpg";